import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/ui/button";
import { useSelector } from "react-redux";

export default function SurveyDashboard() {
  const {user} = useSelector((state) => state.auth);
  const [surveys, setSurveys] = useState([]);
  const navigate = useNavigate();
  console.log(user);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const res = await fetch(`http://localhost:4499/questa/v1/surveys/user/${user._id}`);
        const data = await res.json();
        setSurveys(data);
      } catch (err) {
        console.error("Error loading surveys", err);
      }
    };

    if (user?._id) {
      fetchSurveys();
    }
  }, [user]);

  const handleCreateSurvey = () => {
    navigate(`/survey-builder/${user.publicId}`);
  };

  const handleEditSurvey = (surveyId) => {
    navigate(`/survey-builder?id=${surveyId}`);
  };

  const handleLogout = () => {
    fetch("/api/logout", { method: "POST", credentials: "include" })
      .then(() => navigate("/login"));
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Welcome, {user?.name || "User"}!</h1>

      <div className="flex justify-between items-center mb-4">
        <Button onClick={handleCreateSurvey} className="bg-blue-600 text-white">➕ Create Survey</Button>
        <Button onClick={handleLogout} variant="outline" className="border border-gray-300">Logout</Button>
      </div>

      {surveys.length === 0 ? (
        <p className="text-gray-500 mt-10 text-center">No surveys have been generated yet.</p>
      ) : (
        <div className="space-y-4">
          {surveys.map((survey) => (
            <div key={survey._id} className="p-4 border rounded-xl flex items-center justify-between shadow-sm hover:shadow-md">
              <div>
                <p className="font-semibold text-lg">{survey.title}</p>
                <p className="text-sm text-gray-500">Created: {new Date(survey.createdAt).toLocaleString()}</p>
              </div>
              <div className="flex items-center space-x-2">
                <Button onClick={() => handleEditSurvey(survey._id)} className="bg-indigo-600 text-white">Edit</Button>
                <Button onClick={() => window.open(`/qr/${survey._id}`, '_blank')} className="bg-green-600 text-white">QR Code</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
